import { useEffect } from 'react';

import { connect } from 'react-redux';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { Step } from 'src/app/components/Pages/GetStarted/StepLayout/Step';
import { useSegmentTrack } from 'src/app/hooks/useSegmentTrack';
import { setCurrentOnboardingStep } from 'src/app/state/actions';
import type { Dispatch } from 'src/app/state/store';

import { STEP_NAME } from '../../StepLayout/consts';
import {
  BoldSubheader,
  ButtonContainer,
  IndentedListItem,
  OrderedList,
  StepContainer,
  StepCountHeight,
  StyledButton,
} from '../../styles';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSetCurrentStepToMedications: () => dispatch(setCurrentOnboardingStep(STEP_NAME.MEDICATIONS)),
});

const connector = connect(null, mapDispatchToProps);
const UnconnectedWelcomeBackStep = ({ onSetCurrentStepToMedications, setShowHorizontalProgressBar }) => {
  useEffect(() => {
    setShowHorizontalProgressBar(false);
  }, [setShowHorizontalProgressBar]);

  useSegmentTrack(UNIFIED.viewOnboardingWelcomeBack);

  return (
    <StepContainer>
      <StepCountHeight />
      <Step title={"It's nice to see you again"} text={"Let's pick up where you left off."} hideHeader>
        <BoldSubheader>Up next</BoldSubheader>
        <OrderedList>
          <IndentedListItem>&nbsp;Medications</IndentedListItem>
          <IndentedListItem>Provider information</IndentedListItem>
          <IndentedListItem>Profile information</IndentedListItem>
        </OrderedList>
        <ButtonContainer>
          <StyledButton style={'capsuleBlue50'} size="medium" onClick={onSetCurrentStepToMedications} type="submit">
            Continue
          </StyledButton>
        </ButtonContainer>
      </Step>
    </StepContainer>
  );
};

export const WelcomeBack = connector(UnconnectedWelcomeBackStep);
